import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-applicant-details',
  templateUrl: './applicant-details.component.html',
  styleUrls: ['./applicant-details.component.scss']
})
export class ApplicantDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
